<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.limitations.title')"
        :field-author-and-date="qualification.limitations"
        data-testid="admin-section-tabs-qualification-limitations"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.limitations"
            :placeholder="$t('profile.vetting.qualification.limitations.placeholder')"
            autogrow
            data-testid="vetting-limitations-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.limitations"
            :replace-by="$t('profile.vetting.qualification.limitations.empty.placeholder')"
            data-testid="vetting-limitations"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);
</script>
